import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface HoverEffectProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: string;
}

export function HoverEffect({ 
  children, 
  className,
  glowColor = "rgba(56, 189, 248, 0.3)" // Default cyan glow
}: HoverEffectProps) {
  return (
    <motion.div
      className={cn("relative group", className)}
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
    >
      <motion.div
        className="absolute -inset-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          background: `radial-gradient(circle at center, ${glowColor}, transparent 70%)`,
          filter: 'blur(8px)',
        }}
        initial={false}
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      {children}
    </motion.div>
  );
} 